import React from "react";
import { Paper, Stack } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import ShowWithSkeleton from "src/utils/show-with-skeleton";
import MissionsHistoryTable from "src/scenes/missions-history/missions-history-table";

const MetricCard = styled(Paper)`
    height: 86px;
    width: 100px;
    border-radius: 0;
`;
const MetricTitle = styled.h1`
    font-size: 12px;
    font-weight: 300;
`;
const MetricNumber = styled.h1`
    font-size: 24px;
    font-weight: 500;
    margin: 0;
`;

const MissionsHistory = () => {
    const { isDemo, user } = useAuth();
    const [missions, setMissions] = React.useState("");
    const [missionsStats, setMissionStats] = React.useState("");

    const getMissionsHistory = async () => {
        let response;
        if (isDemo) {
            response = (await import("src/scenes/missions-history/missions-history-mock-data"))
                .default;
        } else {
            response = await request(`/api/missions/history`, { method: "GET" });
        }
        setMissions(response.missions);
        setMissionStats(response.missionStats);
    };
    React.useEffect(() => {
        getMissionsHistory();
    }, []);

    return (
        <>
            <Helmet>
                <title>Adadot - Missions History</title>
            </Helmet>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ width: "100%" }}
            >
                <Stack direction="row" p={1}>
                    <p style={{ paddingRight: "12px", fontWeight: "600" }}>
                        {user && user.displayName}
                    </p>
                    <p style={{ fontWeight: "200" }}>Missions History</p>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MetricCard style={{ borderRadius: "8px 0px 0px 8px" }}>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>All</MetricTitle>
                            <ShowWithSkeleton fetchAction={user} height="100%" width="70%">
                                <MetricNumber>{missionsStats && missionsStats.total}</MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                    <MetricCard>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>Active</MetricTitle>
                            <ShowWithSkeleton fetchAction={user} height="100%" width="70%">
                                <MetricNumber>
                                    {missionsStats && missionsStats["in-progress"]}
                                </MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                    <MetricCard>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>Completed</MetricTitle>
                            <ShowWithSkeleton fetchAction={user} height="100%" width="70%">
                                <MetricNumber>
                                    {missionsStats && missionsStats.completed}
                                </MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                    <MetricCard style={{ borderRadius: "0px 8px 8px 0px" }}>
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <MetricTitle>Failed</MetricTitle>
                            <ShowWithSkeleton fetchAction={user} height="100%" width="70%">
                                <MetricNumber>{missionsStats && missionsStats.failed}</MetricNumber>
                            </ShowWithSkeleton>
                        </Stack>
                    </MetricCard>
                </Stack>
            </Stack>
            {missions.length > 0 && <MissionsHistoryTable missions={missions} />}
        </>
    );
};

export default MissionsHistory;
